export default __webpack_public_path__ + "static/media/bg.be9fab00.png";